import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isNewbuildingSelector, selectDealType, selectOfferType } from 'shared/selectors';
import { selectIsEtazhiBlackFridayPromoOffersEnabled } from 'shared/selectors/etazhiBlackFriday';
import { fetchEtazhiBlackFridayPriceThunk } from 'shared/store/etazhiBlackFriday';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-251228
 */
export function useGetEtazhiBlackFridayPriceData() {
  const dispatch = useDispatch();
  const dealType = useSelector(selectDealType);
  const offerType = useSelector(selectOfferType);
  const isNewbuilding = useSelector(isNewbuildingSelector);
  const isEtazhiBlackFridayPromoOffersEnabled = useSelector(selectIsEtazhiBlackFridayPromoOffersEnabled);

  const shouldMakeRequest =
    // Включена RS всего проекта; включен флаг промо-акций в данных RS; время акции наступило
    isEtazhiBlackFridayPromoOffersEnabled &&
    // Тип недвижимости - квартира
    offerType === 'flat' &&
    // Тип сделки - продажа
    dealType === 'sale' &&
    // Не новостройка
    !isNewbuilding;

  React.useEffect(() => {
    if (shouldMakeRequest) {
      dispatch(fetchEtazhiBlackFridayPriceThunk());
    }
  }, [dispatch, shouldMakeRequest]);
}
